<template>
	<div>
		<v-content>
			<v-container fluid>
              <center><img class="imgLoader" src="../../shared/assets/images/3dloader.gif" v-if="specifierLoaded == false" /></center>
              <v-flex xs3>
                <div class="relative">
                  <a v-if="search != ''" @click.prevent="fncClearSearch" class="searchTypeClear"><i class="material-icons searchTypeClearText">close</i></a>
                  <v-text-field append-icon="search" @input="fncFilterUsers" v-if="specifierLoaded == true" label="Search" solo single-line v-model="search"></v-text-field>
                  <!--<v-text-field append-icon="search" @input="fncFilterUsers" v-if="specifierLoaded == true && search == ''" label="Search" solo single-line v-model="search"></v-text-field>
                  <v-text-field @input="fncFilterUsers" v-if="specifierLoaded == true && search != ''" label="Search" solo single-line v-model="search"></v-text-field><br />-->
                </div>
              </v-flex>
				<v-data-table :headers="headers" v-if="specifierLoaded == true" id="hello" :items="filteredUsers" class="elevation-1 mainTable" hide-actions disable-initial-sort :rows-per-page-items="[2000,40,60,80,100]">
					<template slot="items" slot-scope="props">
                      <tr>
                        <td width="70%" v-if="props.expanded == true" @click="props.expanded = !props.expanded" class="text-xs-right"><i v-if="props.item.branch.length > 0 && search == ''" class="material-icons showHide">arrow_downward</i>{{ fncCompanyName(props.item.label) }}</td>
                        <td width="70%" v-else @click="props.expanded = !props.expanded" class="text-xs-right"><i v-if="props.item.branch.length > 0 && search == ''" class="material-icons showHide">arrow_forward</i>{{ fncCompanyName(props.item.label) }}</td>
                        <td width="20%" class="text-xs-right" v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1"><a @click.prevent="fncViewCompany(props.item.id)"><i class="material-icons">account_box</i></a></td>
                        <td width="10%" class="text-xs-right" v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1"><a @click.prevent="fncEditCompany(props.item)"><i class="material-icons">edit</i></a></td>
                        <!--<td width="10%" class="text-xs-right" v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1"><a @click.prevent="fncDeleteUser(props.item.id, 'company')"><i class="material-icons">delete_forever</i></a></td>-->
                      </tr>
                    </template>
                    <template slot="expand" slot-scope="props">
                      <v-data-table :headers="headersSub" v-if="props.item.branch != ''" :items="props.item.branch" hide-actions class="elevation-1 subTable1 minTable" disable-initial-sort :rows-per-page-items="[20,40,60,80,100]">
                        <template slot="items" slot-scope="props">
                          <tr @click="props.expanded = !props.expanded">
                            <td width="45%" class="text-xs-right">{{ props.item.label }}</td>
                            <td width="20%" class="text-xs-right">{{ props.item.contactno }}</td>
                            <td width="20%" class="text-xs-right">{{ props.item.email }}</td>
                            <td width="10%">
                              <v-menu offset-y>
                                <v-toolbar-side-icon slot="activator"></v-toolbar-side-icon>
                                <v-list>
                                  <v-list-tile @click.prevent="fncLinkUsers(props.item.id)">
                                    <v-list-tile-title>
                                      <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">Link Users</a>
                                    </v-list-tile-title>
                                  </v-list-tile>
                                  <v-list-tile @click.prevent="fncEditPricelist(props.item.id)">
                                    <v-list-tile-title>
                                      <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">Link User Pricelists</a>
                                    </v-list-tile-title>
                                  </v-list-tile>
                                  <v-list-tile @click.prevent="fncEditPassword(props.item.id, props.item.email)">
                                    <v-list-tile-title>
                                      <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">Update Password</a>
                                    </v-list-tile-title>
                                  </v-list-tile>
                                  <!--<v-list-tile @click.prevent="fncEditStatus(props.item.id)">
                                    <v-list-tile-title>
                                      <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">User Statuses</a>
                                    </v-list-tile-title>
                                  </v-list-tile>-->
                                  <v-list-tile @click.prevent="fncViewUser(props.item.id, props.item.region)">
                                    <v-list-tile-title>
                                      <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">User Details</a>
                                    </v-list-tile-title>
                                  </v-list-tile>
                                </v-list>
                              </v-menu>
                            </td>
                            <td width="5%" class="text-xs-right" v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1"><a @click.prevent="fncEditUser(props.item)"><i class="material-icons">edit</i></a></td>
                            <!--<td width="5%" class="text-xs-right" v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1"><a @click.prevent="fncDeleteUser(props.item.id, 'user')"><i class="material-icons">delete_forever</i></a></td>-->
                          </tr>
                        </template>
                      </v-data-table>
                    </template>
				</v-data-table>
			</v-container>
		</v-content>
		<!--<modal></modal>-->
	</div>
</template>

<script>

  import { mapGetters } from 'vuex';
  import Modal from '@/components/shared/modal';

  export default {
    name: 'UserList',
    intRoleEdit: 0,
    data() {
      return {
        search: '',
        filteredUsers: [],
        headers: [
          { text: 'Name', value: 'label', width: '70%' },
          { text: 'Company Details', value: 'details', width: '20%' },
          { text: 'Edit', value: 'edit', width: '10%' }
          /*{ text: 'Delete', value: 'delete', width: '10%' }*/
        ],
        headersSub: [
          { text: 'Name', value: 'name', width: '45%' },
          { text: 'Contact No', value: 'registration_no', width: '20%' },
          { text: 'Email Address', value: 'email', width: '20%' },
          { text: 'User Actions', value: 'actions', width: '10%' },
          /*{ text: 'Link Users', value: 'link' },
          { text: 'User Pricelists', value: 'pricelist' },
          { text: 'Update Password', value: 'password' },
          // { text: 'Assign Company', value: 'status' },
          { text: 'User Status', value: 'status' },
          { text: 'User Details', value: 'details' }, */
          { text: 'Edit', value: 'edit', width: '5%' }
          /*{ text: 'Delete', value: 'delete', width: '5%' }*/
        ]
      }
    },
    methods: {
      fncClearSearch() {
        this.search = '';
        this.fncFilterUsers();
      },
      fncFilterUsers() {
        this.$store.commit({
          type: 'fncFilterUsers',
          search: this.search,
          uType: 'specifier'
        })
      },
      fncExpandProps(props, companyId) {
        this.$store.commit('setCurrentUserCompany', companyId);
        return props.expanded = !props.expanded;
      },
      fncDeleteUser(userId, type) {
        var deleteUser = confirm('Are you sure you want to delete this user?');
        if (deleteUser === true) {
          this.$store.dispatch({
            type: 'fncDeleteUser',
            userId: userId,
            context: 3,
            deleteType: type
          })
        }
      },
      fncEditPassword(userId, userEmail) {
        var updatePassword = confirm('Are you sure you want to update the users password?');
        if (updatePassword === true) {
          this.$store.dispatch({
            type: 'fncUpdateUserPassword',
            userId: userId,
            userEmail: userEmail
          })
        }
      },
      fncEditPricelist(userId) {
        this.$store.dispatch({
          type: 'fncEditUserPricelist',
          userId: userId
        })
      },
      fncEditStatus(userId) {
        this.$store.dispatch({
          type: 'fncEditStatus',
          userId: userId,
          status: 'quote'

        })
      },
      fncEditCompany(userId) {
        this.$store.dispatch({
          type: 'fncEditUserCompanies',
          userId: userId,
          listType: 2,
          context: 2
        })
      },
      fncViewCompany(companyId) {
        this.$store.dispatch('fncViewCompany', companyId);
      },
      fncLinkUsers(userId) {
        this.$store.commit('fncEmptyUserLinks');
        var modalDetails = { title: 'Link Users', component: 'modal-user-link', mstate: true, params: { userId: userId, userType: 1 } };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });
      },
      fncEditUser(user) {
        this.$store.dispatch('fncSetEditUser', user);
        this.$store.dispatch('fncPopulateUserRegions');
        this.$store.dispatch('fncSetupUserCreate', '');
      },
      fncEditCompany(company) {
        this.$store.commit('fncSetObjCompanyEdit', company);
        var companyName = company.label.replace(/<(?:.|\n)*?>/gm, '');
        var modalDetails = { title: 'Edit User - ' + companyName, component: 'modal-company-update', mstate: true, params: { context: 2 } };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });
      },
      fncCompanyName(companyName) {
        return companyName.replace(/<(?:.|\n)*?>/gm, '');;
      },
      fncViewUser(userId, regions) {
        this.$store.dispatch({
          type: 'fncViewUser',
          userId: userId,
          regions: regions
        })
      }
    },
    computed: {
      ...mapGetters([
        'objAuthorize',
        'specificUsers',
        'specificUserSearch',
        'specifierLoaded'
      ])
    },
    beforeMount() {
      this.$store.dispatch({
        type: 'fncPopulateUsers',
        context: 3
      });
    },
    watch: {
      specificUsers() {
        this.filteredUsers = this.specificUsers;
      },
      specificUserSearch() {
        if (this.search == '') {
          this.filteredUsers = this.specificUsers;
        } else {
          this.filteredUsers = this.specificUserSearch;
        }
      }
    }
  }
</script>

<style scoped>
  @import '../../shared/assets/css/shared.css'
</style>
